import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import classes from './Footer.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moobitekLogo from '../../assets/MoobitekLogos/MoobitekFinalLogowhite.png';
import moobitekLogoWhite from '../../assets/MoobitekLogos/MoobitekFinalLogofullcolor.png';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import {
  faFacebookF,
  faXTwitter,
  faInstagram,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons';
import GamingLabsCertifiedReverse from '../../assets/MoobitekLogos/GamingLabsCertifiedReverse.png';
import pdfFile from '../../assets/pdfFiles/InformationSecurityPolicy.pdf';
import packageJson from '../../../package.json';

function Footer({ whiteVersion }) {
  const currentYear = new Date().getFullYear();
  const version = packageJson.version;
  const [dropDown, setDropDown] = useState('hidden');

  const handleDownload = (pdfPath, filename) => {
    const link = document.createElement('a');
    link.href = pdfPath;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const openDropDown = () => {
    setDropDown((currentValue) =>
      currentValue === 'visible' ? 'hidden' : 'visible',
    );
  };
  return (
    <footer className={`${classes.footer} ${classes[whiteVersion]}`}>
      <div>
        <div className={classes.linksMoobi}>
          <Link to='/' className={classes.mobileLogo}>
            {whiteVersion ? (
              <img
                src={moobitekLogoWhite}
                alt='moobitek Logo '
                className={classes.logo}
              />
            ) : (
              <img
                src={moobitekLogo}
                alt='moobitek Logo '
                className={classes.logo}
              />
            )}
          </Link>
          <ul className={classes.ul_list} style={{ padding: '0', margin: '0' }}>
            <li className={classes.navigateTabs}>
              <Link
                to='/AboutUs'
                className={`${classes.list_wordFirst} ${classes[whiteVersion]}`}
              >
                Why Moobitek
              </Link>
            </li>
            <li className={classes.navigateTabs}>
              <Link
                to='/Publications'
                className={`${classes.list_wordFirst} ${classes[whiteVersion]}`}
              >
                Publications
              </Link>
            </li>
            <li className={classes.navigateTabs}>
              <Link
                to='/ContactUs'
                className={`${classes.list_wordFirst} ${classes[whiteVersion]}`}
              >
                Contact Us
              </Link>
            </li>
            <li className={classes.navigateTabsSecond} onClick={openDropDown}>
              <Link
                to=''
                className={`${classes.list_wordFirst + ' ' + classes.verticalsMeth} } ${classes[whiteVersion]}`}
              >
                Verticals
              </Link>
              <FontAwesomeIcon
                className={`
               ${classes.iconClose} 
              ${dropDown === 'visible' ? classes.up : ''} 
               ${whiteVersion ? classes.white : classes.dark}
                `}
                icon={faChevronDown}
              />
            </li>
          </ul>
          <div
            className={`${classes.dropdownContent} ${
              dropDown === 'visible' ? classes.visible : ''
            }`}
          >
            <ul className={classes.ul_listSecond} style={{ padding: '0' }}>
              <li className={classes.navigateTabsSecond}>
                <Link
                  to='/MoobiPlus'
                  className={`${classes.list_wordSecondLink} ${classes[whiteVersion]}`}
                >
                  MoobiPlus
                </Link>
              </li>
              <li className={classes.navigateTabsSecond}>
                <Link
                  to='/MoobiVault'
                  className={`${classes.list_wordSecondLink} ${classes[whiteVersion]}`}
                >
                  MoobiVault
                </Link>
              </li>
              <li className={classes.navigateTabsSecond}>
                <Link
                  to='/MoobiPay'
                  className={`${classes.list_wordSecondLink} ${classes[whiteVersion]}`}
                >
                  MoobiPay
                </Link>
              </li>
              <li className={classes.navigateTabsSecond}>
                <Link
                  to='/MoobiDev'
                  className={`${classes.list_wordSecondLink} ${classes[whiteVersion]}`}
                >
                  MoobiDev
                </Link>
              </li>
            </ul>
          </div>
          <div className={classes.desktop}>
            <ul className={classes.ul_listSecond1} style={{ padding: '0' }}>
              <li className={classes.navigateTabsSecond1}>
                <Link
                  to='/MoobiPlus'
                  className={`${classes.list_wordSecondLink1} ${classes[whiteVersion]}`}
                >
                  MoobiPlus
                </Link>
              </li>
              <li className={classes.navigateTabsSecond1}>
                <Link
                  to='/MoobiVault'
                  className={`${classes.list_wordSecondLink1} ${classes[whiteVersion]}`}
                >
                  MoobiVault
                </Link>
              </li>
              <li className={classes.navigateTabsSecond1}>
                <Link
                  to='/MoobiPay'
                  className={`${classes.list_wordSecondLink1} ${classes[whiteVersion]}`}
                >
                  MoobiPay
                </Link>
              </li>
              <li className={classes.navigateTabsSecond1}>
                <Link
                  to='/MoobiDev'
                  className={`${classes.list_wordSecondLink1} ${classes[whiteVersion]}`}
                >
                  MoobiDev
                </Link>
              </li>
            </ul>
          </div>
          <div className={classes.gamingMedia}>
            <a
              href='https://access.gaminglabs.com/Certificate/Index?i=568'
              target='_blank'
              rel='noopener noreferrer'
            >
              <img
                src={GamingLabsCertifiedReverse}
                className={classes.gamingStyleLogo}
              />
            </a>
            <div className={classes.footerStyle}>
              <div>
                <a
                  href='https://www.facebook.com/Moobitek'
                  target='_blank'
                  rel='noreferrer'
                >
                  <FontAwesomeIcon
                    icon={faFacebookF}
                    color={whiteVersion ? ' #101018' : 'white'}
                    className={classes.mediaIcon}
                  />
                </a>
                <a
                  href='https://twitter.com/i/flow/login?redirect_after_login=%2Fmoobitek'
                  target='_blank'
                  rel='noreferrer'
                >
                  <FontAwesomeIcon
                    icon={faXTwitter}
                    color={whiteVersion ? ' #101018' : 'white'}
                    className={classes.mediaIcon}
                  />
                </a>
                <a
                  href='https://www.linkedin.com/company/moobitek'
                  target='_blank'
                  rel='noreferrer'
                >
                  <FontAwesomeIcon
                    icon={faLinkedin}
                    color={whiteVersion ? ' #101018' : 'white'}
                    className={classes.mediaIcon}
                  />
                </a>
                <a
                  href='https://www.instagram.com/moobitek.leb'
                  target='_blank'
                  rel='noreferrer'
                >
                  <FontAwesomeIcon
                    icon={faInstagram}
                    color={whiteVersion ? ' #101018' : 'white'}
                    className={classes.mediaIcon}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className={`${classes.lineSeperate} ${classes[whiteVersion]}`} />
        <div className={classes.logoMediaContainer}>
          <Link to='/'>
            {whiteVersion ? (
              <img
                src={moobitekLogoWhite}
                alt='moobitek Logo '
                className={classes.logoMobile}
              />
            ) : (
              <img
                src={moobitekLogo}
                alt='moobitek Logo '
                className={classes.logoMobile}
              />
            )}
          </Link>
          <div className={classes.rightPrivacyStyle}>
            <div className={classes.rightPrivacyStyle}>
              <a
                href='https://access.gaminglabs.com/Certificate/Index?i=568'
                target='_blank'
                rel='noopener noreferrer'
              >
                <img
                  src={GamingLabsCertifiedReverse}
                  className={classes.gamingStyleLogoMobile}
                />
              </a>
              <span
                className={`${classes.policySentence} ${classes[whiteVersion]}`}
                onClick={() =>
                  handleDownload(pdfFile, 'Information Security Policy.pdf')
                }
              >
                Policies
              </span>
            </div>
            <span
              className={`${classes.rightsSentence} ${classes[whiteVersion]}`}
            >
              © {currentYear} Moobitek LLC <small>{version}</small>
            </span>
            <span
              className={`${classes.policySentence1} ${classes[whiteVersion]}`}
              onClick={() =>
                handleDownload(pdfFile, 'Information Security Policy.pdf')
              }
            >
              Policies
            </span>
          </div>

          <div className={classes.footerStyleMobile}>
            <div>
              <a
                href='https://www.facebook.com/Moobitek'
                target='_blank'
                rel='noreferrer'
              >
                <FontAwesomeIcon
                  icon={faFacebookF}
                  color={whiteVersion ? ' #101018' : 'white'}
                  className={classes.mediaIcon}
                />
              </a>
              <a
                href='https://twitter.com/i/flow/login?redirect_after_login=%2Fmoobitek'
                target='_blank'
                rel='noreferrer'
              >
                <FontAwesomeIcon
                  icon={faXTwitter}
                  color={whiteVersion ? ' #101018' : 'white'}
                  className={classes.mediaIcon}
                />
              </a>
              <a
                href='https://www.linkedin.com/company/moobitek'
                target='_blank'
                rel='noreferrer'
              >
                <FontAwesomeIcon
                  icon={faLinkedin}
                  color={whiteVersion ? ' #101018' : 'white'}
                  className={classes.mediaIcon}
                />
              </a>
              <a
                href='https://www.instagram.com/moobitek.leb'
                target='_blank'
                rel='noreferrer'
              >
                <FontAwesomeIcon
                  icon={faInstagram}
                  color={whiteVersion ? ' #101018' : 'white'}
                  className={classes.mediaIcon}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
